<div class="grid-x">
    <div class="cell shrink-font">
        Context Target for Report Template: (e.g. $.data.reportTemplate):
        <input type="text" [(ngModel)]="componentData.config.reportTarget">
    </div>
    <div class="cell shrink-font">
        Context Target for Chief's Order #: (e.g. $.reporting.chiefOrderNumber )
        <span class="red bold">Not fully implemented; do not change this value!</span>
        <input type="text" [(ngModel)]="componentData.config.chiefsOrderNumber" />
    </div>
    <div class="cell shrink-font">
        Context Target for Certified Mail # (e.g. $.reporting.cerifiedMailId)
        <span class="red bold">Not fully implemented; do not change this value!</span>
        <input type="text" [(ngModel)]="componentData.config.certifiedMailId" />
    </div>
    <div class="cell shrink-font">
        <div class="checkbox">
            <label>
                <input class="show-for-sr" type="checkbox" id="chkBanner" [(ngModel)]="componentData.config.useBanner" />
                <label aria-hidden="true" for="chkBanner" class="inline">
                    <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
                    <span class="control-label-text">Use Banner on First Page</span>
                </label>
            </label>
        </div>
    </div>
    <div class="cell shrink-font">
        <div class="checkbox">
            <label>
                <input class="show-for-sr" type="checkbox" id="chkChiefOrderHeader" [(ngModel)]="componentData.config.useChiefsOrderHeader" />
                <label aria-hidden="true" for="chkChiefOrderHeader" class="inline">
                    <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
                    <span class="control-label-text">Use Chief's Order Header</span>
                </label>
            </label>
        </div>
    </div>
    <div class="cell shrink-font">
        <div class="checkbox">
            <label>
                <input class="show-for-sr" type="checkbox" id="chkPageNumberHeader" [(ngModel)]="componentData.config.usePageNumberHeader" />
                <label aria-hidden="true" for="chkPageNumberHeader" class="inline">
                    <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
                    <span class="control-label-text">Use Page Number Header</span>
                </label>
            </label>
        </div>
    </div>
</div>